// The public Activity card on a server page (servers/_activity): session opens and closes arrive over ActionCable
// (ServerActivityChannel) as { kind: "joined" | "left", name, at, profile } and are drawn with DOM APIs only, newest
// first, 20 kept. The live pill shows while the socket is connected. Anyone can connect: no sign-in needed.
import { createConsumer } from "@rails/actioncable"

const card = document.querySelector("[data-activity-address]")

if (card) {
  const list = card.querySelector("[data-activity-list]")
  const empty = card.querySelector("[data-activity-empty]")
  const pill = card.querySelector("[data-activity-live]")
  const words = { joined: card.dataset.joined, left: card.dataset.left }
  const clock = new Intl.DateTimeFormat(undefined, { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: card.dataset.zone })

  const add = ({ kind, name, at, profile }) => {
    if (!words[kind]) return
    const line = document.createElement("li")
    line.className = "feed__line"
    line.dataset.kind = kind
    const time = document.createElement("time")
    time.className = "feed__time"
    time.dateTime = at
    time.textContent = clock.format(new Date(at))
    const text = document.createElement("span")
    text.className = "feed__text"
    const who = document.createElement(profile ? "a" : "b")
    who.className = "feed__name"
    if (profile) who.href = profile
    who.textContent = name
    text.append(who, ` ${words[kind]}`)
    line.append(time, text)
    list.prepend(line)
    while (list.children.length > 20) list.lastElementChild.remove()
    if (empty) empty.hidden = true
  }

  createConsumer().subscriptions.create({ channel: "ServerActivityChannel", address: card.dataset.activityAddress }, {
    connected: () => { pill.hidden = false },
    disconnected: () => { pill.hidden = true },
    rejected: () => { pill.hidden = true },
    received: add,
  })
}
